import { objectDuckCreator } from '@atc/modular-redux';

export default objectDuckCreator({
    namespace: 'HOMESERVICES',
    storePrefix: 'homeservices',
    store: 'content',
    initialState: {
        owner: {},
        listings: [],
        fetchedHomeServicesDealerLot: false,
    },
});
